import { render, staticRenderFns } from "./credit-memo-allocations.vue?vue&type=template&id=361eb8fe&"
import script from "./credit-memo-allocations.vue?vue&type=script&lang=js&"
export * from "./credit-memo-allocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports